import React from 'react';
import './style.css';

const BottomText = ({ children }) => {
  return <div className="bottom-text">{children}</div>;
};

export default BottomText;
